/**
 * @generated SignedSource<<b9fd26d8ea440c3315d30fdcc98a3091>>
 * @relayHash f1a1e7f4f3391d9025cda1e1a967eac2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a6cc55bf7b732ac37d40318c8c8e923f5e4fb306144d2d271a0d55c3f0909b71

import type { ConcreteRequest, Query } from 'relay-runtime';
export type coloredLabelsUpdater_getLabelsInBoardQuery$variables = {
  boardId: string;
};
export type coloredLabelsUpdater_getLabelsInBoardQuery$data = {
  readonly jira: {
    readonly labelsInBoard: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: {
            readonly colorKey: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type coloredLabelsUpdater_getLabelsInBoardQuery = {
  response: coloredLabelsUpdater_getLabelsInBoardQuery$data;
  variables: coloredLabelsUpdater_getLabelsInBoardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "colorKey"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "labelsInBoard",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraLabel",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "concreteType": "JiraColor",
                        "kind": "LinkedField",
                        "name": "color",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "labelsInBoard",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraLabel",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "concreteType": "JiraColor",
                        "kind": "LinkedField",
                        "name": "color",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a6cc55bf7b732ac37d40318c8c8e923f5e4fb306144d2d271a0d55c3f0909b71",
    "metadata": {},
    "name": "coloredLabelsUpdater_getLabelsInBoardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ae1319e8a8b2f29c250f16107724930b";

export default node;
